// ═══════════════════════════════════════════════════════════════
// RichTextView – a leírás megjelenítése: formázott (szűrt HTML) vagy sima szöveg,
// benne az élő blokkokkal (szervezeti diagram, kapcsolattartók, kapcsolt szervek, kapcsolati térkép)
// ═══════════════════════════════════════════════════════════════
import React, { useMemo } from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import { LiveBlock, hasLiveToken, splitLiveTokens } from '../personnel/PersonnelBlock';

interface Props {
  html?: string | null;
  text?: React.ReactNode;
  className?: string;
}

export const RichTextView: React.FC<Props> = ({ html, text, className = '' }) => {
  const safe = useMemo(() => (html ? sanitizeHtml(html) : ''), [html]);
  const plain = typeof text === 'string' ? text : null;
  const parts = useMemo(() => {
    if (safe && hasLiveToken(safe)) return splitLiveTokens(safe);
    if (!safe && plain && hasLiveToken(plain)) return splitLiveTokens(plain);
    return null;
  }, [safe, plain]);

  if (parts) {
    return (
      <div className={`${safe ? 'rich-text' : ''} ${className}`}>
        {parts.map((p, i) => p.type === 'token'
          ? <LiveBlock key={i} token={p.token} />
          : safe
            ? <div key={i} dangerouslySetInnerHTML={{ __html: p.value }} />
            : <span key={i} className="whitespace-pre-wrap">{p.value}</span>)}
      </div>
    );
  }
  if (safe) return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: safe }} />;
  return <div className={`whitespace-pre-wrap ${className}`}>{text}</div>;
};

export default RichTextView;
